const seoMeta = {
  "/": {
    title: "VCNR Group",
    description:
      "VCNR Technologies, part of VCNR Group, delivers the best hospitality and services curated to meet the evolving industry demands with utmost precision and care.",
    keywords:
      "VCNR Technologies, agriculture, buildings, construction, drone for farming in india, hospitality and services, VCNR group, agri tech companies",
  },
    "/aboutVCNR": {
    title: "About VCNR",
    description:
      "VCNR Technologies, part of VCNR Group, delivers the best hospitality and services curated to meet the evolving industry demands with utmost precision and care.",
    keywords:
      "VCNR Technologies, agriculture, buildings, construction, drone for farming in india, hospitality and services, VCNR group, agri tech companies",
  },
  "/Career": {
    title: "Apply for Internships Today At VCNR Group | VCNR Group ",
    description:
      "Apply for internships at VCNR Group and take the first steps toward career growth. Explore real-world experience, mentorship, and future job opportunities.",
    keywords:
      "apply for internships, job opportunities, career growth, home care hiring, get hired immediately",
  },
  "/Contact": {
    title: "Contact Us And Book An Appointment Today! | VCNR Group ",
    description:
      "Have questions? Contact us to book an appointment and visit your nearest VCNR Group location. Our team offers prompt support, care, and the best services.",
    keywords:
      "contact us, book an appointment, location, warehouse construction near me, office in bangalore",
  },
  "/Leadership": {
    title: "Meet The Leadership Team At VCNR Group | VCNR Group ",
    description:
      "Meet the leadership team at VCNR Group, driving innovation and excellence across industries. Learn about their vision, expertise, and commitment to growth.",
    keywords:
      "leadership team, innovation, excellence, business growth, company vision, executive team",
  },
  "/Agrotech": {
    title: "The Latest Drone For Pesticides By VCNR Group | VCNR Group.",
    description:
      "VCNR Group offers the best agriculture drone for spraying fertilizer and pesticides for crops, especially made for farmers and the development of their yields.",
    keywords:
      "drone for pesticides, drone pesticide spraying, drone for farming in india, drone pesticide sprayer price, drone for agriculture india, pesticide drone, precision farming india, farm automation india, drone farming india, ai agriculture india",
  },
  "/Healthcare": {
    title: "Revolutionizing Healthcare Services | VCNR Group",
    description:
      "VCNR Healthcare offers advanced medical technologies, diagnostics, and hospital infrastructure to provide quality healthcare services to communities across India.",
    keywords:
      "healthcare services, medical technology, hospitals in India, diagnostics, multi-speciality hospitals, VCNR healthcare solutions",
  },
  "/Builders": {
    title: "Top Builders in Bangalore | VCNR Group Real Estate",
    description:
      "VCNR Builders are redefining real estate with modern design, structural integrity, and sustainable architecture across Bangalore and India.",
    keywords:
      "top builders in bangalore, construction company india, real estate projects, VCNR buildings, residential and commercial construction",
  },
  "/Foundation": {
    title: "Hitachinthana Trust – Uplifting Communities Through Service",
    description:
      "The Hitachinthana Trust focuses on rural development, education, healthcare, and empowerment initiatives to bring impactful change to underprivileged communities.",
    keywords:
      "Hitachinthana Trust, trust work, rural development, healthcare outreach, community support programs, women empowerment india",
  },
  "/Hospitality": {
    title: "Premium Hospitality and Wellness Services | VCNR Group",
    description:
      "Offering premium hotels, wellness retreats, and top-tier hospitality services across India that ensure comfort, luxury, and customer satisfaction.",
    keywords:
      "hospitality services, wellness retreats, premium hotels india, luxury accommodation, VCNR hospitality, customer experience",
  },
  "/Goldandiamonds": {
    title: "Luxury Gold and Diamond Collections | VCNR Jewels",
    description:
      "Explore exquisite gold and diamond jewelry collections from VCNR Group — quality craftsmanship and timeless elegance for every occasion.",
    keywords:
      "gold and diamond jewelry, VCNR jewels, luxury ornaments, wedding rings, designer collections, precious stones india",
  },
  "/Technologies": {
    title: "Technology-Driven Innovations by VCNR | Future Solutions",
    description:
      "Driving innovation through cutting-edge technologies in automation, AI, IoT, and smart solutions — shaping the digital future with VCNR Technologies.",
    keywords:
      "VCNR technologies, AI solutions, smart automation, tech innovations, digital transformation, IoT systems, future-ready tech",
  },
  "/educational": {
    title: "VCNR Educational Trust – Empowering Through Knowledge",
    description:
      "VCNR Educational Trust is dedicated to creating educational opportunities that empower individuals and communities. The trust encompasses multiple initiatives, including Hithachinthana School and our Nursing College, ensuring access to quality education, skill-building, and professional development.",
    keywords:
      "VCNR Educational Trust, quality education, skill-building, professional development, Hithachinthana School, Nursing College, community empowerment",
  },
  "/Properties": {
    title: "VCNR Properties – Innovative Real Estate Solutions",
    description:
      "VCNR Properties creates sustainable and innovative spaces that enrich communities and lives.",
    keywords:
      "VCNR Properties, sustainable real estate, innovative spaces, community living, properties development india",
  },
};

export default seoMeta;
